module.exports = __webpack_public_path__ + "static/lewin-fdb71e43cb66a3f28f72dadf140b22a3.png";